const resource = {
    resource_identifier_in_use: 'API 識別碼 {{indicator}} 已經被使用',
};
export default Object.freeze(resource);
